import React from "react";
import { TextField, Autocomplete } from "@mui/material";
import { NavigateFunction } from "react-router-dom";

export const AddGroupUserStepOne = ({
  newUserInfo,
  setNewUserInfo,
  parentAccounts,
  parentNames,
  navigate,
}: {
  newUserInfo: any;
  setNewUserInfo: any;
  parentAccounts: any;
  parentNames: any;
  navigate: NavigateFunction;
}) => {
  const [emailValue, setEmailValue] = React.useState(newUserInfo.email);

  const [firstNameValue, setFirstNameValue] = React.useState(
    newUserInfo.first_name
  );

  const [lastNameValue, setLastNameValue] = React.useState(
    newUserInfo.last_name
  );

  return (
    <div>
      <div className="absolute top-[160px] left-[30px]">
        <Autocomplete
          disablePortal
          value={
            newUserInfo.group
              ? {
                  id: newUserInfo.group,
                  name: parentNames.get(newUserInfo.group) ?? "",
                }
              : null
          }
          options={
            parentAccounts[0]
              ? parentAccounts.map((object: any, index: number) => ({
                id: object.id,
                name: object.name,
                index: index,
              }))
              : []
          }
          getOptionLabel={(option) => option.name || ""}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          onChange={(event: any, newInputValue: any) => {
            setNewUserInfo((previousState: any) => ({
              ...previousState,
              group: newInputValue?.id ?? "",
            }));
          }}
          sx={{ width: 350 }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label="Group *"
              autoComplete="off"
              id="group_name"
              name="group_name"
            />
          )}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          )}
        />
        <br></br>
        <TextField
          variant="standard"
          label="Email *"
          value={emailValue}
          onChange={(event) => {
            setNewUserInfo((previousState: any) => {
              return { ...previousState, email: event.target.value };
            });
            setEmailValue(event.target.value);
          }}
          sx={{ width: "350px" }}
          helperText=""
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          variant="standard"
          label="First Name *"
          value={firstNameValue}
          onChange={(event) => {
            setNewUserInfo((previousState: any) => {
              return { ...previousState, first_name: event.target.value };
            });
            setFirstNameValue(event.target.value);
          }}
          sx={{ width: "350px" }}
          helperText=""
          type="string"
        />
        <br></br>
        <br></br>{" "}
        <TextField
          variant="standard"
          label="Last Name *"
          value={lastNameValue}
          onChange={(event) => {
            setNewUserInfo((previousState: any) => {
              return { ...previousState, last_name: event.target.value };
            });
            setLastNameValue(event.target.value);
          }}
          sx={{ width: "350px" }}
          helperText=""
          type="string"
        />
        <br></br>
        <br></br>
        <br></br>
        <br></br>{" "}
        <p className="font-mulish absolute text-black">{`* Required fields`}</p>
      </div>
    </div>
  );
};